import { Link } from "react-router-dom";
import { useFullCurrentUser } from "@/hooks/useCurrentUser";
import { useGetClimberContentSubscriptions } from "@/hooks/useGetClimberContentSubscriptions";
import { Box, Paper, Typography } from "@mui/material";

export const HlDebug = () => {
  const { activeUserRecord } = useFullCurrentUser();
  const climberId =
    activeUserRecord?.role === "climber"
      ? activeUserRecord?.userID || activeUserRecord?.id
      : null;
  const { data: subs = [], isLoading: subsLoading } =
    useGetClimberContentSubscriptions(climberId ?? "", !!climberId);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {climberId && (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Climber subscription featureIDs
          </Typography>
          {subsLoading ? (
            <Typography color="text.secondary">Loading…</Typography>
          ) : subs.length === 0 ? (
            <Typography color="text.secondary">No subscriptions</Typography>
          ) : (
            subs.map((sub) => (
              <Box key={sub.id} sx={{ mb: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  {sub.id}
                </Typography>
                <Typography
                  component="pre"
                  sx={{ fontSize: "0.875rem", fontFamily: "monospace" }}
                >
                  {JSON.stringify(sub.featureIDs ?? [], null, 2)}
                </Typography>
              </Box>
            ))
          )}
        </Paper>
      )}
      <ul>
        <li>
          <Link to="facets">Facets</Link> - Info about current user facets
        </li>
        <li>
          <Link to="awards">Awards</Link> - Info about current user awards
        </li>
        <li>
          <Link to="next-steps">Next Steps</Link> - Debug next steps
          recommendation engine
        </li>
        <li>
          <Link to="palette">Palette</Link> - Overall app color palette
        </li>
        <li>
          <Link to="flags">Flags</Link> - Debugging feature flags (and product
          plan)
        </li>
        <li>
          <Link to="reset-user">Reset User</Link> - DANGER: Reset current user
          data
        </li>
        <li>
          <Link to="ms-hats-country">Hats Debug</Link> - List 10-at-a-time hats
          by region type
        </li>
        <li>
          <Link to="pdf-preview">PDF Preview</Link> - Preview Career Plan PDF
          without downloading
        </li>
        <li>
          <Link to="course-plan-pdf-preview">Course Plan PDF Preview</Link> -
          Preview Course Plan PDF with fake data for live editing
        </li>
      </ul>
    </Box>
  );
};
